/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Types of playback restrictions that may prevent or interrupt playback.
 * Used by RestrictionManager to communicate blocking conditions.
 */
export enum PlaybackRestrictionType {
  /**
   * Content is restricted due to adult/mature rating.
   */
  ADULT = "ADULT",

  /**
   * Application moved to background.
   */
  APP_BACKGROUND = "APP_BACKGROUND",

  /**
   * Application returned to foreground.
   */
  APP_FOREGROUND = "APP_FOREGROUND",

  /**
   * Content is blacklisted and cannot be played.
   */
  BLACKLISTED = "BLACKLISTED",

  /**
   * Device type is not authorized for this content.
   */
  DEVICE_RESTRICTED = "DEVICE_RESTRICTED",

  /**
   * In-home location service returned an error.
   */
  INHOME_LOCATION_ERROR = "INHOME_LOCATION_ERROR",

  /**
   * In-home location service is unreachable.
   */
  INHOME_LOCATION_UNREACHABLE = "INHOME_LOCATION_UNREACHABLE",

  /**
   * Network connection restored.
   */
  NETWORK_CONNECTED = "NETWORK_CONNECTED",

  /**
   * Network connection lost.
   */
  NETWORK_DISCONNECTED = "NETWORK_DISCONNECTED",

  /**
   * No restriction - playback is allowed.
   */
  NO_RESTRICTION = "NO_RESTRICTION",

  /**
   * User is outside the home network.
   */
  OUT_OF_HOME = "OUT_OF_HOME",

  /**
   * User is outside the authorized geographic region.
   */
  OUT_OF_REGION = "OUT_OF_REGION",

  /**
   * User is not subscribed to this content.
   */
  UNSUBSCRIBED = "UNSUBSCRIBED"
}
